import {
    borderBox,
    clickHereButton,
    content,
    icon, mobileBtn,
    wrapper
} from "@/components/mhealth-studio/more-info/styles/more-info";
import {useTranslation} from "react-i18next";

const MoreInfo = () => {
    const {t} = useTranslation()

    return (
        <section className={wrapper}>
            <div className={borderBox}>
                <img alt={"Question mark in blue circle"} src={"/assets/images/mhealth/more-info/question.png"}
                     className={icon}/>
                {/*{t("mhealth.more-info.description")}*/}
                <p className={content}>For more information <br/> <span
                    className={"font-bold"}>about mHealth Studio</span></p>
                <a href={"mailto:sales@hearxgroup.com?subject=mHealth Studio Enquiry"}>
                    <button
                        className={`${clickHereButton} mobile:hidden tablet:block`}>{t("mhealth.more-info.button.title")}</button>
                    <button
                        className={`${mobileBtn} tablet:hidden`}>{t("mhealth.more-info.button.title")}</button>
                </a>
            </div>
        </section>
    )
}

export default MoreInfo
